import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { LocalStorageKeys } from '../../LocalStorageKeys';
import { getLocationApiResult } from '../../utils/locationUtils';
import { AppConfig } from '../config/config.service';
import { StorefrontPolicyService } from '../firstlight/storefront-policy/storefront-policy.service';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { LocationAPIResult } from './models/location-result';
import { RegionAPIResult } from './models/region-result';

@Injectable({
  providedIn: 'root',
})
export class RuleService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private localStorage: LocalStorageService,
    private policyService: StorefrontPolicyService
  ) {}

  /**
   * Get country code saved
   *
   * @returns
   */
  getCountryCode(): string {
    const location: RegionAPIResult = this.localStorage.getItem(LocalStorageKeys.LOCATION)
      ? JSON.parse(this.localStorage.getItem(LocalStorageKeys.LOCATION))
      : null;
    if (location) {
      const region = location?.countryCode?.toLowerCase();
      return region;
    }
    return 'all';
  }

  public async getHttpGeolocation(appConfig: AppConfig, authDataToken: string): Promise<RegionAPIResult> {
    // TODO: return location from local storage if available
    return this.getGeolocation(appConfig, authDataToken);
  }

  public isAllowedRegion(): boolean {
    // const availableRegions = this.configService.applicationConfig.allowedRegions.replace(',gt', '');
    const availableRegions = this.configService.applicationConfig.allowedRegions;
    const region = availableRegions.split(',');
    const currentRegion = this.localStorage.getItem(LocalStorageKeys.COUNTRY_CODE);
    return region.includes(currentRegion?.toLowerCase());
  }
  private async getGeolocation(appConfig: AppConfig, authDataToken: string): Promise<RegionAPIResult> {
    try {
      const url = `${appConfig.geoLocationURL}/device/location/lookup`;
      const headers = new HttpHeaders({
        'content-type': 'application/json',
        Authorization: `Bearer ${authDataToken}`,
      });
      const regionAPIResult = await this.http
        .get<LocationAPIResult>(url, { headers })
        .toPromise()
        .then((res) => getLocationApiResult(res));
      this.localStorage.setItem(LocalStorageKeys.CITY, regionAPIResult.city);
      this.localStorage.setItem(LocalStorageKeys.REGION, regionAPIResult.region);
      this.localStorage.setItem(LocalStorageKeys.CHANNEL, (regionAPIResult.channel ?? []).toString());
      this.policyService.setChannels(regionAPIResult);
      return Promise.resolve(regionAPIResult);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
